// extracted by mini-css-extract-plugin
export default {"root":"ItemLabel_root__YixM2","icon":"ItemLabel_icon__3BaNB","label":"ItemLabel_label__srq3+","primary":"ItemLabel_primary__JSHq1"};